import { useQuery } from "@tanstack/react-query";
import { clubApi } from "../../club-api-client";
import { queryKeys } from "../query-keys";

export function useAttendance(clubId: string | null, from: string | null, to: string | null) {
	return useQuery({
		enabled: !!clubId && !!from && !!to,
		queryFn: () => clubApi.training.attendance.get(clubId!, { from: from!, to: to! }),
		queryKey: queryKeys.clubPortal.attendance(clubId ?? "", from ?? "", to ?? ""),
	});
}
